import { Component } from "react";

export default class HeaderRouteName extends Component {
  render() {
    return (
      <div className="row wrapper white-bg page-heading">
        <div className="col-lg-12">
          <ol className="breadcrumb">
            <li style={{ fontSize: 18 }}>Confirmation</li>
            {this.props.nestedRouteNames.map((routeName) => (
              <li key={routeName} style={{ fontSize: 18 }}>
                {routeName}
              </li>
            ))}
          </ol>
        </div>
      </div>
    );
  }
}
